(function () {
  'use strict';
  if (window.__focalRevealInit) return;
  window.__focalRevealInit = true;

  function reveal() {
    var els = document.querySelectorAll('.focal-reveal:not(.is-visible)');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    els.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }

  /* Re-scan periodically in case sections are added dynamically
     (e.g. via the theme editor) */
  var mo = new MutationObserver(function () { reveal(); });
  mo.observe(document.body, { childList: true, subtree: true });
})();
